






















import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import TrainDataStatisticsAll from '@/trials/views/trials/train/data/TrainDataStatisticsAll.vue';
import TrainDataStatisticsNa from '@/trials/views/trials/train/data/TrainDataStatisticsNa.vue';
import TrainDataStatisticsLabels from '@/trials/views/trials/train/data/TrainDataStatisticsLabels.vue';

@Component({
    components: { TrainDataStatisticsAll, TrainDataStatisticsNa, TrainDataStatisticsLabels },
})
export default class TrainDataStatistics extends Vue {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private labelName: string = '';
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // ラベル行に設定されたカラム名を保持
        this.labelName = sessionModule.getTrainingData.labelName;
    }
}
